import React from "react";

interface ModalProps {
    children: React.ReactNode;
}

const ModalNoClose: React.FC<ModalProps> = ({ children }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg relative my-auto max-h-[calc(100dvh-2rem)] overflow-y-auto overscroll-contain">
                {children}
            </div>
        </div>
    );
};

export default ModalNoClose;
